import type { PlaylistMode } from "src/utils/playlist";

import DefaultActionBar from "./DefaultActionBar";
import MosActionBar from "./MosActionBar";

export type PlaylistActionBarProps = {
	playlistId: string | null;
	mode: PlaylistMode;
	editable: boolean;
	onToggleEditable?: (value: boolean) => void;
	onAddGraphic: () => void;
	onEdit: () => void;
};

export default function PlaylistActionBar(props: PlaylistActionBarProps) {
	switch (props.mode) {
		case "mos":
			return <MosActionBar {...props} />;
		default:
			return <DefaultActionBar {...props} />;
	}
}
